
































import Vue from 'vue'
export default Vue.extend({
    mounted(){

        const dropdowns = document.querySelectorAll("a.dropdown");
        dropdowns.forEach(d => {
            const el = d as HTMLElement;
            el.addEventListener('mouseover', () => {

                const inner = (el.children[1]! as HTMLElement);
                const icon = (el.children[0]! as HTMLElement);

                inner.style.opacity = "1"
                inner.style.pointerEvents = "all"
                inner.style.transform = "translateY(0)"
                icon.style.transform = "rotate(180deg) scale(0.6)"
                inner.addEventListener('mouseout', () => {
                    inner.style.opacity = "0"
                    inner.style.pointerEvents = "none"
                    inner.style.transform = "translateY(-20px)"
                    icon.style.transform = "rotate(0) scale(0.6)"
                })

            })
        })

    }
})
